import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Subject} from 'rxjs/Subject';
import {BsModalRef} from 'ngx-bootstrap';
import {CorsiService} from '../../formativa/corsi.service';
import * as _ from 'lodash';
import {ModalGenericService} from '../../../shared/modal-generic/modal-generic.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-cerca-tesserato-multy',
  templateUrl: './cerca-tesserato-multy.component.html'
})

export class CercaTesseratoMultyComponent implements OnInit {

  formatori: any[] = []
  courseId: number;
  buttonPrefix;
  isStudent: boolean;
  enableCardCode: boolean;
  regularForm: FormGroup;
  partecipant: any[];
  checkCanAdd: boolean;
  competitionId: any;
  projectId: any;
  selectedFormatore: any[] = [];
  selectedFormatoreIndex: number;
  lettere: any;
  all: any[]
  letterSel: any;
  bsModalRef2: BsModalRef;
  public onClose: Subject<any>;
  public onAdd: Subject<any>;
  public onUpdatePartecipant: Subject<any>;
  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private corsiService: CorsiService,
    private genericModalService: ModalGenericService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.onClose = new Subject();
    this.onAdd = new Subject();
    this.onUpdatePartecipant = new Subject();

    this.onUpdatePartecipant.subscribe((p) => {
        this.partecipant  = p;

      _.remove(this.formatori, (n) => {
          return _.find(this.partecipant, (p) => {return p.fkCard == n.fkCard}) != undefined  || _.find(this.selectedFormatore, (p) => {return p.fkCard == n.fkCard}) != undefined;
        });
    });
    console.log(this.projectId)
    if (this.projectId != null) {
      this.corsiService.projectsearchSubscriberCompetition(this.projectId).subscribe((res) => {
        console.log(this.partecipant);
        this.formatori = res;
        this.all = res;

        /*_.remove(this.formatori, (n) => {
          return _.find(this.partecipant, (p) => {return p.fkCard == n.fkCard}) != undefined  || _.find(this.selectedFormatore, (p) => {return p.fkCard == n.fkCard}) != undefined;
        });*/
        this.selectedFormatore = [];

        const obj = _.groupBy(this.formatori, function(o) {
          return o.lastname.substr(0, 1);
        });
        this.lettere = [];

        _.forEach(obj, (o, k) => {this.lettere.push({key: k, values: o})});

        this.letterSel = null;

      });
    } else {
      this.corsiService.searchSubscriberCompetition(this.competitionId).subscribe((res) => {
        console.log(this.partecipant);
        this.formatori = res;
        this.all = res;
        _.remove(this.formatori, (n) => {
          return _.find(this.partecipant, (p) => {return p.fkCard == n.fkCard}) != undefined  || _.find(this.selectedFormatore, (p) => {return p.fkCard == n.fkCard}) != undefined;
        });
        this.selectedFormatore = [];

        const obj = _.groupBy(this.formatori, function(o) {
          return o.lastname.substr(0, 1);
        });
        this.lettere = [];

        _.forEach(obj, (o, k) => {this.lettere.push({key: k, values: o})});

        this.letterSel = null;

      });
    }

    // this.inizializeForm();
  }

  loadSub(l) {
    if (l == null) {
      this.formatori = this.all;
      this.letterSel = null;
    } else {
      this.formatori = l.values;
      this.letterSel = l.key;
    }
  }



  selectFormatore(formatore: any) {
    /*if (this.checkCanAdd ) {
    if (formatore.canAdd) {
      if (_.find(this.selectedFormatore, (p) => {
        return p.fkCard == formatore.fkCard
      }) != undefined) {
        this.removeFormatore(formatore)

      } else {
        this.selectedFormatore.push(formatore);

      }
    }else{
      this.bsModalRef2 = this.genericModalService.open({
        title: 'CF: ' + formatore.cf,
        closeButton: 'Chiudi',
        message: 'Per aggiungere il tesserato al corso bisogna completare la sua anagrafica inserendo la mail ed il telefono. Puoi cliccare su Modifica Tesserato per andare ad aggiornare i campi.',
        buttons: ["Modifica tesserato"]
      });
      this.bsModalRef2.content.onClose.subscribe(result => {
        this.router.navigate(['/servizi/tesseramento/tesserato/edit/', formatore.idSubscriber]);
      });
    }
    }else{*/
      if (_.find(this.selectedFormatore, (p) => {
        return p.fkCard == formatore.fkCard
      }) != undefined) {
        this.removeFormatore(formatore)

      } else {
        this.selectedFormatore.push(formatore);

      }
    // }

  }
  removeFormatore(formatore: any) {
    _.remove(this.selectedFormatore, (n) => {
      return n.fkCard == formatore.fkCard;
    });
  }
  isSelected(formatore) {
    return _.find(this.selectedFormatore, (p) => {return p.fkCard == formatore.fkCard}) != undefined;
  }
  selezionaTutti() {
    _.forEach(this.formatori, (f) => {
      if (_.find(this.selectedFormatore, (p) => {
        return p.fkCard == f.fkCard
      }) != undefined) {

      } else {
        this.selectedFormatore.push(f);

      }
    }) ;
  }
  aggiungiFormatore() {
    this.onAdd.next(this.selectedFormatore);
    this.selectedFormatore = [];
    if(this.projectId != null) {this.bsModalRef.hide();}

    }
  chiudi() {
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/servizi/tesseramento/cerca-tesserato-multy/cerca-tesserato-multy.component.ts